import { render, staticRenderFns } from "./EnquiryDataForm.vue?vue&type=template&id=06c43e98&"
import script from "./EnquiryDataForm.vue?vue&type=script&lang=js&"
export * from "./EnquiryDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput})
